import { ONEPARK_BOOKINGS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: ONEPARK_BOOKINGS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/OneparkBookings'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/oneparkBookings/index.js